import { useQuery } from '@tanstack/react-query';

import API from '@api/API';

export const useSourceEventIdsQuery = (eventIds: string[], isEnabled = true) => {
  const sortedEventIds = [...eventIds].sort();

  const { isFetched, data, refetch } = useQuery({
    queryKey: useSourceEventIdsQuery.queryKey(sortedEventIds),
    queryFn: () => {
      const queryParams = new URLSearchParams();
      sortedEventIds.forEach((eventId) => queryParams.append('eventIds', eventId));

      return API.get<{ sourceEventIdsByEventId: Record<string, string[]> }>(
        `/v1/super-admin/events/source-event-ids?${queryParams.toString()}`,
      );
    },
    enabled: isEnabled,
  });

  return {
    sourceEventIdsAreReady: isFetched,
    sourceEventIdsByEventId: data?.sourceEventIdsByEventId,
    refetchSourceEventIds: refetch,
  };
};
useSourceEventIdsQuery.queryKey = (sortedEventIds: string[]) => [
  'super-admin',
  'events',
  'source-event-ids',
  sortedEventIds,
];
